module.exports = __webpack_public_path__ + "static/demo-image-02-d2e555296b69175fd50ab5e38594b130.jpg";